import { render, staticRenderFns } from "./ModalBackDropComponent.vue?vue&type=template&id=0b379d85"
import script from "./ModalBackDropComponent.vue?vue&type=script&lang=js"
export * from "./ModalBackDropComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports